import "../styles/forgotPassword.css";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";
import Icon from "../assets/Icon";

const UserLock = () => {
  let checkMailuserEmail = localStorage.getItem("userEmail");

  return (
    <>
      <Row className="min-h-[100vh]">
        <Col md={24}>
          <Row className="w-full">
            <Col md={24}>
              <p id="hirePPLogo" className="mt-2">
                {/* <Icon type="hire-logo" width={80} height={60} /> */}
                <Icon type="jobdrona-logo" width={50} height={32} />
                <span className="font-bold text-orangish text-[1.25rem]">
                  JobDrona
                </span>
              </p>
            </Col>
          </Row>
          <div className="mt-4"></div>
          <Row className="">
            <Col md={24}>
              <p className="passPatterns leftSide">
                <Icon type="placeholderPatterns" width={273} height={407} />
              </p>
            </Col>
            <Col md={24} className="flex justify-center items-center">
              {/* <h2>Check your mail</h2> */}
              <Row className="w-full">
                <Col md={24} className="flex justify-center w-full">
                  <Icon type="CheckMailSvg" width={100} height={80} />
                </Col>
                <Col
                  md={24}
                  className="w-full text-center mt-[12vh] font-semibold px-2"
                >
                  <div
                    style={{ fontSize: "clamp(26px, 6vw, 45px)" }}
                    className="leading-[2.1rem]"
                  >
                    Your Account has been Locked
                  </div>
                </Col>
                <Col
                  md={24}
                  className="flex justify-center mt-[0.86rem] w-full items-center px-2"
                >
                  <p className="text-[1.1rem] text-[#344054] items-center text-center">
                    <span>Please reach out to us at </span>
                    <a
                      href="mailto:support@hireplusplus.com"
                      className="text-[#206DC5] font-semibold"
                    >
                      support@hireplusplus.com
                    </a>
                    .
                  </p>
                </Col>
                <Col
                  md={24}
                  className="flex justify-center  items-center text-[red] w-full text-2xl mt-4"
                >
                  <p>{checkMailuserEmail}</p>
                </Col>

                <Col
                  md={24}
                  className="flex justify-center mt-2 w-full text-[1rem]"
                >
                  <span>
                    Back to{" "}
                    <Link to="/login" className="text-[#206DC5] font-semibold">
                      Login
                    </Link>
                  </span>
                </Col>
              </Row>
            </Col>
            <div className="flex justify-end passPatterns rightSide">
              <p className="">
                <Icon type="placeholderPatterns" width={273} height={407} />
              </p>
            </div>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default UserLock;
